import axios from 'axios'

import { getDeviceId } from '@/features/api/getDeviceId.util.js'

export function createClient(baseURL) {
  const client = axios.create({
    baseURL,
    headers: {
      'X-Device-Id': getDeviceId(),
    },
  })

  client.interceptors.response.use(
    response => response,
    error => {
      return Promise.reject(error)
    },
  )

  return client
}
